import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useHistory } from 'react-router-dom';
import { fetchData, updateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import { Link } from 'react-router-dom';
import Button from '@mui/material/Button';
import Select from 'react-select';
import CircularProgress from '@mui/material/CircularProgress';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Tooltip } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

const CustomerEdit = ({ match }) => {
  const history = useHistory();
  const recordId = match.params.id;
  const { id } = useParams();
  const { isAuthenticated, companyId, userId, token, logout } = useAuth();
  const [successMessages, setSuccessMessages] = useState("");
  const [errorMessages, setErrorMessages] = useState("");

  useEffect(() => {
    if (isAuthenticated && tokenIsExpired(token)) {
      logout();
      return;
    }
  }, [isAuthenticated, token, logout]);

  const [formData, setFormData] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    fetchData('CustomerApi', `/CustomerEdit/${id}`, token)
      .then((response) => {
        if (response.responseCode === '1111') {
          setFormData(response.response_data);
        }
      })
      .catch((error) => {
        console.error('Error fetching Customer Details:', error);
      });
  }, [id]);


  const formatDateForInput = (dateString) => {
    const currentDate = new Date(dateString);
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const day = String(currentDate.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));
  };


  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);

    if (!formData.name) {
      setErrorMessages("Name are required!");
      setIsLoading(false);
      return;
    }

    if (!formData.contactNumber1) {
      setErrorMessages("Contact Number are required!");
      setIsLoading(false);
      return;
    }

    if (!formData.addressLine1) {
      setErrorMessages("Address Line 1 are required!");
      setIsLoading(false);
      return;
    }

    const updatedFormData = {
      ...formData,
      companyId: companyId,
      UpdatedBy: userId,
    };

    try {
      await updateData('CustomerApi', `${id}`, updatedFormData, token);
      history.push('/CustomerIndex');
    } catch (error) {
      console.error('Error updating record:', error);
      setIsLoading(false);
    }
  };


  return (

    <div className="w-full max-w-sm container mt-6 mx-auto">
      <form onSubmit={handleSubmit}>
        <div className='w-full mb-2 flex items-center'>
          <h6 className='productHead flex-grow linkcolor' style={{ color: 'black', fontFamily: 'Georgia, serif', fontWeight: 'bolder' }}>CUSTOMER EDIT</h6>

          <Tooltip title="Exit">
            <Link to="/CustomerIndex" style={{ color: 'red', textDecoration: 'none', fontWeight: 'bolder' }}>
              <Button style={{ color: 'brown', fontWeight: 'bolder' }}>
                Back To List <ArrowForwardIosIcon />
              </Button>
            </Link>
          </Tooltip>


          <Tooltip title="Update">

            <Button onClick={handleSubmit} style={{ color: 'green', fontWeight: 'bolder' }} disabled={isLoading}>
              {isLoading ? <CircularProgress size={24} color="inherit" /> : "Update"} <CheckCircleIcon />
            </Button>

          </Tooltip>

        </div>

        {errorMessages && <p className="text-red-500 text-center">{errorMessages}</p>}
        {successMessages && <p className="text-green-500 text-center">{successMessages}</p>}

        <div className="w-full mb-4 flex">

          <div className="w-1/2 mr-2">
            <label className="block uppercase tracking-wide text-black text-xs font-bold mr-2" htmlFor="Name">
              Name <span className="text-red-500">*</span>
            </label>
            <input
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
              name="name"
              value={formData.name}
              onChange={handleChange}
              type="text"
              placeholder="Enter Name"
            />
          </div>

          <div className="w-1/4 mr-2">
            <label className="block uppercase tracking-wide text-black text-xs font-bold mr-2" htmlFor="contactNumber1">
              Contact No:1 <span className="text-red-500">*</span>
            </label>
            <input
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
              name="contactNumber1"
              value={formData.contactNumber1}
              onChange={handleChange}
              type="text"
              placeholder="Contact Number 1"
            />
          </div>

          <div className="w-1/4 mr-2">
            <label className="block uppercase tracking-wide text-black text-xs font-bold mr-2" htmlFor="contactNumber2">
              Contact No:2
            </label>
            <input
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
              name="contactNumber2"
              value={formData.contactNumber2}
              onChange={handleChange}
              type="text"
              placeholder="Contact Number 2"
            />
          </div>

          <div className="w-1/3 mr-2">
            <label className="block uppercase tracking-wide text-black text-xs font-bold mr-2" htmlFor="email">
              Email
            </label>
            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
              name="email"
              value={formData.email}
              onChange={handleChange}
              type="text"
              placeholder="Email"
            />
          </div>


        </div>

        <div className="w-full mb-4 flex">

          <div className="w-1/3 mr-2">
            <label className="block uppercase tracking-wide text-black text-xs font-bold mr-2" htmlFor=" GST No">
              GST NUMBER
            </label>
            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
              name="gstNumber"
              value={formData.gstNumber}
              onChange={handleChange}
              type="text"
              placeholder=" GST No" />
          </div>

          <div className="w-1/2 mr-2">
            <label className="block uppercase tracking-wide text-black text-xs font-bold mr-2" htmlFor="AddressLine1">
              Address Line 1<span className="text-red-500">*</span>
            </label>
            <textarea className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
              name="addressLine1"
              value={formData.addressLine1}
              onChange={handleChange}
              type="text"
              placeholder="Address Line 1"
              rows={1}
            />
          </div>

          <div className="w-1/2 mr-2">
            <label className="block uppercase tracking-wide text-black text-xs font-bold mr-2" htmlFor="AddressLine2">
              Address Line 2
            </label>
            <textarea className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
              name="adressLine2"
              value={formData.adressLine2}
              onChange={handleChange}
              type="text"
              placeholder="Address Line 2"
              rows={1}
            />
          </div>
          <div className="w-1/3 mr-2">
            <label className="block uppercase tracking-wide text-black text-xs font-bold mr-2" htmlFor="Location">
              Location
            </label>
            <textarea className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
              name="location"
              value={formData.location}
              onChange={handleChange}
              type="text"
              placeholder="Location"
              rows={1}
            />
          </div>

        </div>
        <div className="w-full mb-4 flex">


          <div className="w-full md:w-1/3 mb-2 md:mb-0 md:mr-2">
            <label className="block uppercase tracking-wide text-black text-xs font-bold mr-2" htmlFor="openingbalance">
              Opening Balance
            </label>
            <input
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
              value={formData.openingBalance}
              name="openingBalance"
              onChange={handleChange}
              type="text"
              placeholder="Opening Balance"
              style={{textAlign: 'right'}}
              maxLength={10}
            />
          </div>
          <div className="w-full md:w-1/3 mb-2 md:mb-0 md:mr-2">
            <label className="block uppercase tracking-wide text-black text-xs font-bold mr-2" htmlFor="Event">
              Event
            </label>
            <input
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
              value={formData.event}
              name="event"
              onChange={handleChange}
              type="text"
              placeholder="Event"
            />
          </div>
          <div className="w-full md:w-1/3 mb-2 md:mb-0 md:mr-2">
            <label className="block uppercase tracking-wide text-black text-xs font-bold mr-2" htmlFor="eventDescription">
              Event Description
            </label>
            <input
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
              value={formData.eventDescription}
              name="eventDescription"
              onChange={handleChange}
              type="text"
              placeholder="Event Description"
            />
          </div>
          <div className="w-4/5 mr-2">
            <label className="block uppercase tracking-wide text-black text-xs font-bold mr-2" htmlFor="CustomerRemark">
              Customer Remark
            </label>
            <textarea
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
              value={formData.customerRemark}
              onChange={handleChange}
              name="customerRemark"
              type="text"
              placeholder="Enter Customer Remark"
              rows={1}
            />
          </div>
        </div>

      </form >

    </div >

  );
};

export default CustomerEdit;
